/* eslint-disable @eslint-react/no-array-index-key */

'use client';

import { ResponsiveFullBleedBackground } from './Internals/ResponsiveFullBleedBackground';

export const ResponsiveNavigationLoading = () => (
  <>
    {/* h-6 is necessary because, for unknown reasons, otherwise the height with 32px content and 8px padding results in 52px total height instead of the intended 48px */}
    <div aria-busy className="h-6 cursor-wait p-1 lg:hidden">
      <div className="icon-emp-burger-text text-color-grey h-4 w-4 animate-pulse" />
    </div>
    <nav aria-busy className="relative max-lg:hidden">
      <ResponsiveFullBleedBackground className="border-color-grey border-y" />
      <div className="flex h-[calc(2.75rem+2px)] items-center">
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className="bg-color-grey-light text-size-body-base mx-1 h-[1em] flex-1 animate-pulse rounded-sm"
          />
        ))}
      </div>
    </nav>
  </>
);
